import { Div, Ref, SelectOption, Span, Select } from '@tblabs/truffle';


export class SelectInputWithIcon extends Div
{
    constructor(label: string, ref: Ref<number>, options: object | SelectOption<number>[], info: string)
    {
        super();
        this.Class("number-input-with-icon tooltip");

        this.Append(
            new Span(info).Class("tooltip-text"),
            new Span(label).Class("icon"),
            new Select(ref, options).RemoveAllClasses().Class("input")
        );
    }
}
